exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2VchisQgM6eWyR00Y-9d_Y{font-size:11px}", ""]);
// Exports
exports.locals = {
	"roomSecondaryText": "_2VchisQgM6eWyR00Y-9d_Y"
};